module.exports = __webpack_public_path__ + "img/th.1747b72c.svg";